// Dynamic API URL configuration
export const getApiBaseUrl = () => {
  // Check for environment variable first (for production)
  if (process.env.REACT_APP_API_URL) {
    console.log('Using REACT_APP_API_URL from env:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // If accessing from localhost, use localhost backend
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    console.log('API Base URL: Using localhost backend');
    return 'http://localhost:5000';
  }
  
  // For production domains, use the same protocol and hostname as the frontend
  // This ensures HTTPS frontend uses HTTPS backend to avoid mixed content errors
  // Assumes reverse proxy setup where API is at same domain (e.g., https://app.playlivepro.com/api)
  const backendProtocol = protocol; // Use the same protocol as frontend (https: or http:)
  
  // For production HTTPS, assume reverse proxy setup - use same domain without port
  // For HTTP, use port 5000 (development/staging)
  if (protocol === 'https:') {
    // Production HTTPS: assume reverse proxy (nginx) routes /api to backend
    const apiUrl = `${backendProtocol}//${hostname}`;
    console.log('🚀 API Base URL configured (HTTPS, reverse proxy):', apiUrl, '| Hostname:', hostname);
    return apiUrl;
  } else {
    // HTTP: use port 5000 directly
    const apiUrl = `${backendProtocol}//${hostname}:5000`;
    console.log('🚀 API Base URL configured (HTTP):', apiUrl, '| Hostname:', hostname);
    return apiUrl;
  }
};

// Evaluate at module load time
const computedApiUrl = getApiBaseUrl();
console.log('📡 API_BASE_URL constant set to:', computedApiUrl);
export const API_BASE_URL = computedApiUrl;

/**
 * Get the Socket.io connection URL
 * Ensures Socket.io uses the correct backend URL and doesn't infer from the current page
 */
export const getSocketUrl = () => {
  const apiUrl = API_BASE_URL;
  
  // Parse the URL to ensure proper format
  try {
    const url = new URL(apiUrl);
    // Return the origin (protocol + hostname + port) for Socket.io
    // Socket.io will append its own path (/socket.io/)
    const socketUrl = url.origin;
    console.log('🔌 Socket.io URL:', socketUrl);
    return socketUrl;
  } catch (e) {
    // Fallback if URL parsing fails
    console.warn('Failed to parse API URL, using as-is:', apiUrl);
    return apiUrl;
  }
};
